import { CurrencyAmountPipe } from '@aca-new/app/shared/pipes/currency-amount/currency-amount.pipe';
import { FileNameToMimeTypePipe } from '@aca-new/app/shared/pipes/file-name-to-mime-type/file-name-to-mime-type.pipe';
import { FormatAsiaMacauDatePipe } from '@aca-new/app/shared/pipes/format-asia-macau-date/format-asia-macau-date.pipe';
import { ByPassSecurityTrustPipe } from '@aca-new/app/shared/pipes/pass-security-trust.pipe';
import { TableBadgeLabelPipe } from '@aca-new/app/shared/pipes/table-badge/table-badge-label.pipe';
import { ToBooleanPipe } from '@aca-new/app/shared/pipes/to-boolean.pipe';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [ToBooleanPipe, TableBadgeLabelPipe, ByPassSecurityTrustPipe],
  imports: [FormatAsiaMacauDatePipe, CurrencyAmountPipe, FileNameToMimeTypePipe],
  exports: [ToBooleanPipe, TableBadgeLabelPipe, ByPassSecurityTrustPipe, FormatAsiaMacauDatePipe, CurrencyAmountPipe, FileNameToMimeTypePipe],
})
export class AppCommonPipeModule {}
